module.exports = __webpack_public_path__ + "img/info_round_g.962a613b.svg";